import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "../ui/alert-dialog";

/**
 * The guard on the bin icon in the feed.
 *
 * The icon sits in a row of taps people make constantly — like, comment, copy
 * — on a card that is often thumb-height on a phone, and the delete behind it
 * is a server-side DELETE with nothing to undo it. So the confirmation lands
 * before the request, not as a toast after.
 *
 * The description does the real work: the fear on tapping this is losing the
 * workout, and the workout is not what goes.
 */
const DeletePostDialog = ({ open, onOpenChange, onConfirm, title }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>Remove this workout from the feed?</AlertDialogTitle>
        <AlertDialogDescription>
          {title ? (
            <>
              &ldquo;{title}&rdquo; stays in your history &mdash; only the post
              your mates see is removed.
            </>
          ) : (
            <>
              The session stays in your history &mdash; only the post your mates
              see is removed.
            </>
          )}{" "}
          Its likes and comments go with it, and this cannot be undone.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel>Cancel</AlertDialogCancel>
        <AlertDialogAction
          className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
          onClick={onConfirm}
        >
          Remove
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export default DeletePostDialog;
